const WorkerHelper = {
  getSalaryDeviationMealDatesWorker: () => {
    return new Worker(new URL("../../worker/salaryDeviationMealDatesWorker.ts", import.meta.url));
  },
  getSalaryDeviationLeaveDatesWorker: () => {
    return new Worker(new URL("../../worker/salaryDeviationLeaveDatesWorker.ts", import.meta.url));
  },
};
export default WorkerHelper;
